import React, { useCallback, useEffect, useState } from "react";
import "./Cart.css";
import { FaTrash } from "react-icons/fa";
import { BsCart4 } from "react-icons/bs";
import { useWarta } from "../../../context/WartaContext";
import { Tooltip } from "react-tooltip";
import { Info } from "lucide-react";
import api from "../../../services/baseUrl";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";

export default function Cart() {
  const navigate = useNavigate();
  const [totalCheckout, setTotalCheckout] = useState(0.0);
  const { cartData, setCartData, checkoutArray, setCheckoutArray } = useWarta();
  const userId = JSON.parse(Cookies.get("wartaUser")).userId;

  const calculateTotalPrice = useCallback((item) => {
    const ctcFee = item.ctc !== 0 ? 5 : 0;
    const pageCount = item.wartaDocumentId.totalPages;

    const total = (pageCount * 5 + ctcFee) * 1.08;
    return total.toFixed(2);
  }, []);

  const countTotal = useCallback(
    (array) => {
      let total = 0;
      array.forEach((item) => {
        total += parseFloat(calculateTotalPrice(item));
      });
      setTotalCheckout(parseFloat(total.toFixed(2)));
    },
    [calculateTotalPrice]
  );

  useEffect(() => {
    countTotal(checkoutArray);
  }, [checkoutArray, countTotal]);

  const handleCheckboxChange = (item) => {
    let newCheckoutArray = [];
    if (checkoutArray.some((i) => i.id === item.id)) {
      newCheckoutArray = checkoutArray.filter((i) => i.id !== item.id);
    } else {
      newCheckoutArray = [...checkoutArray, item];
    }
    setCheckoutArray(newCheckoutArray);
    countTotal(newCheckoutArray);
  };

  const selectAll = () => {
    if (checkoutArray.length !== cartData.length) {
      setCheckoutArray(cartData);
      countTotal(cartData);
    } else {
      setCheckoutArray([]);
      setTotalCheckout(0.0);
    }
  };

  const updateCtc = async (item, lang) => {
    toast.info("Updating cart", { autoClose: 3000 });
    let ctc = 0;
    if (item.ctc === lang) {
      if (lang === 2) {
        ctc = 1;
      }

      if (lang === 1) {
        ctc = 0;
      }
    } else {
      if (item.ctc === 2 && lang === 1) {
        ctc = 0;
      } else {
        ctc = lang;
      }
    }
    const response = await api.put("/ewarta/cart/update/ctc", {
      userId,
      wartaDocumentId: item.wartaDocumentId.id,
      ctc,
    });

    if (response.status === 200) {
      toast.success("Updated CTC", { autoClose: 3000 });
      reloadCart();
    }
  };

  const reloadCart = async () => {
    const response = await api.post("/ewarta/cart/get", {
      userId,
    });
    if (response.status === 200) {
      setCartData(response.data);
    }
  };

  const deleteCart = async (wartaDocumentId) => {
    try {
      const response = await api.post("/ewarta/cart/remove", {
        userId,
        wartaDocumentId,
      });

      if (response.status === 200) {
        reloadCart();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="warta-cart-container">
      <div className="warta-cart-header">
        <h1>Shopping Basket</h1>
        <p>
          Kindly review your items in the shopping basket before completing your
          gazette purchase
        </p>
      </div>
      <div className="warta-cart-body">
        <table>
          <thead>
            <tr>
              <td>Query</td>
              <td>
                <div className="td-content">
                  Quantity (Pages)
                  <span
                    data-tooltip-id="my-tooltip"
                    data-tooltip-html="Quantity inclusive of <br/>gazette cover page"
                  >
                    <Info size={15} />
                  </span>
                </div>
              </td>
              <td>
                <div className="td-content">
                  CTC
                  <span
                    data-tooltip-id="my-tooltip"
                    data-tooltip-html="Please note that a charge of
                  <br/> RM5 applies for CTC
                  <br/>(Certified True Copy) requests."
                  >
                    <Info size={15} />
                  </span>
                </div>
              </td>
              <td>
                <div className="td-content">
                  BM&nbsp;CTC
                  <span
                    data-tooltip-id="my-tooltip"
                    data-tooltip-html="Please check if <br/>you want BM CTC <br/>(Default CTC: English)"
                  >
                    <Info size={15} />
                  </span>
                </div>
                <Tooltip id="my-tooltip" style={{ color: "white" }} />
              </td>

              <td>
                <div className="td-content">
                  Total Price (RM)
                  <span
                    data-tooltip-id="my-tooltip"
                    data-tooltip-html="Unit Price: RM5 per page"
                  >
                    <Info size={15} />
                  </span>
                </div>
              </td>
              <td onClick={selectAll} style={{ cursor: "pointer" }}>
                Select All
              </td>
            </tr>
          </thead>
          <tbody>
            {cartData.map((item) => {
              const queryParts = item.request.query.split(" | ");

              const isSingleValue = queryParts.every(
                (part) => !part.includes(":")
              );
              return (
                <tr key={item.id}>
                  <td className="title">
                    {" "}
                    {isSingleValue ? (
                      <ul style={{ padding: 0, listStyleType: "none" }}>
                        <li>{item.request.query}</li>
                      </ul>
                    ) : (
                      <ul style={{ padding: 0, listStyleType: "none" }}>
                        {queryParts.map((part, index) => {
                          const [key, value] = part.split(": ");
                          return (
                            <li key={index}>
                              <strong>
                                {key
                                  ? key.charAt(0).toUpperCase() + key.slice(1)
                                  : ""}
                                :
                              </strong>{" "}
                              {value}
                            </li>
                          );
                        })}
                      </ul>
                    )}
                  </td>
                  <td>{item.wartaDocumentId.totalPages}</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={item.ctc !== 0}
                      onChange={() => updateCtc(item, 1)}
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      checked={item.ctc === 2}
                      onChange={() => updateCtc(item, 2)}
                      disabled={item.ctc === 0}
                    />
                  </td>
                  <td>{calculateTotalPrice(item)}</td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={checkoutArray.some((i) => i.id === item.id)}
                        onChange={() => handleCheckboxChange(item)}
                      />
                      <FaTrash
                        onClick={() => deleteCart(item.wartaDocumentId.id)}
                        style={{ color: "#0099f3", cursor: "pointer" }}
                      />
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div className="warta-cart-footer">
        <button className="warta-cart-button">
          <strong>Total: RM {totalCheckout.toFixed(2)}</strong>
        </button>
        <button
          className="warta-cart-button"
          onClick={() => {
            if (checkoutArray.length > 0) {
              navigate("/payment", { state: checkoutArray });
            } else {
              toast.warning("Please choose at least one document.", {
                autoClose: 3000,
              });
            }
          }}
          style={{ cursor: "pointer" }}
        >
          <BsCart4 style={{ marginRight: "5px" }} />
          Proceed to Payment ({checkoutArray.length})
        </button>
      </div>
      <div className="warta-cart-disclaimer">
        <i>Price inclusive of 8% SST</i>
      </div>
      <ToastContainer />
    </div>
  );
}
